import axios from 'src/utils/axios';
import { endpoints } from 'src/utils/api-endpoints';
import { Organization } from 'src/models/organization';
import { AppResponse } from 'src/models/app-response';


export async function GetOrganization(_id: string): Promise<{ organization: Organization[]; error: unknown }> {
  const URL = `${endpoints.organization.getOrganization}/${_id}`;
  try {
    const response = await axios.get(URL);
    return {
      organization: response.data.data || [],
      error: null,
    };
  } catch (error) {
    console.error('Error fetching procedures:', error);
    return {
      organization: [],
      error,
    };
  }
}

export async function getAllOrganizations(): Promise<{ organizations: Organization[]; error: string | null }> {
  const URL = `${endpoints.organization.getAllOrganizations}`;
  try {
    const response = await axios.get(URL);
    return {
      organizations: response.data || [],
      error: null,
    };
  } catch (error) {
    console.error('Error fetching all organizations:', error);
    return {
      organizations: [],
      error,
    };
  }
}

export async function deleteOrganization(_id: string): Promise<AppResponse<Organization>> {
  const URL = `${endpoints.organization.deleteOrganization}/${_id}`;
  try {
    const response = await axios.delete(URL);
    return response.data;
  } catch (error) {
    console.error('Error deleting organization:', error);
    throw error;
  }
}

export async function editOrganization(organizationData: Partial<Organization> & { _id: string }): Promise<AppResponse<Organization>> {
  const { _id } = organizationData; 
  const url = `${endpoints.organization.editOrganization}/${_id}`;
  const response = await axios.post<AppResponse<Organization>>(url, organizationData);
  return response.data;
}

export async function setOrganizationSuspension(
  organizationId: string,
  suspend: boolean,
  reason?: string,
): Promise<AppResponse<Organization>> {
  try {
    const response = await axios.post(
      endpoints.organization.setOrganizationSuspension(organizationId),
      { suspend, reason },
    );
    return response.data;
  } catch (error) {
    return { success: false, data: undefined, error: (error as Error)?.message ?? error };
  }
}

export type CreateOrganizationPayload = {
  name: string;
  phone?: string;
  country?: string;
  address?: string;
  timezone?: string;
  adminFirstName: string;
  adminLastName?: string;
  adminEmail: string;
};

export async function superAdminCreateOrganization(
  payload: CreateOrganizationPayload
): Promise<AppResponse<{ organization: Organization; adminUser: { _id: string; email: string } }>> {
  try {
    const response = await axios.post(
      endpoints.organization.superAdminCreateOrganization,
      payload
    );
    return response.data;
  } catch (error) {
    return { success: false, data: undefined, error: (error as Error)?.message ?? error };
  }
}

export async function getOrganizationSummary(orgId: string): Promise<AppResponse<{
  activeUserCount: number;
  skillCount: number;
  jobRoleCount: number;
  avgCompletion: number;
  totalEvaluations: number;
}>> {
  try {
    const url = `${endpoints.organization.summeryOrganization(orgId)}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Failed to get org summary:', error);
    return { success: false, data: undefined, error };
  }
}
